// extracted by mini-css-extract-plugin
export var lg = "_3a-4";
export var md = "_3a-3";
export var sm = "_3a-2";
export var xs = "_3a-1";
export var xxs = "_3a-0";